/**
 * /t/$slug/recovery — public recovery flow.
 */

import { createFileRoute } from "@tanstack/react-router";
import { RecoveryPage } from "@/features/recovery/pages/recovery-page";

export const Route = createFileRoute("/t/$slug/recovery")({
  component: RecoveryPage,
});
